import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import { TranslateService } from '@ngx-translate/core';
import { CKEditor4 } from 'ckeditor4-angular';
import { Subscription } from 'rxjs';
import { WordcountService } from '../../../../wordcount.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
declare function initSliders(): any
declare var decimalInput: any;

@Component({
  selector: 'app-carrousel',
  templateUrl: './carrousel.html',
  styleUrls: ['./carrousel.scss']
})

export class Carrousel implements OnInit {

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public context = "";
  public supplementary = "";
  public questionId = 0;
  public allClosed = true;
  public ckString: string = '';
  public ckeConfig: any;


  public showBlock = false;
  public shownElements: string[] = [];
  public labels: { [name: string]: SafeHtml } = {};

  private loadAnswersSubscription: Subscription;



  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService,
    public wordCount: WordcountService,
    public sanitizer: DomSanitizer
  ) {
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if (exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== "") {
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else {
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    this.ckeConfig = {
      toolbarGroups: [
        { name: 'styles', groups: [ 'styles' ] },
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'colors', groups: [ 'colors' ] },
        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
        { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
        { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
        { name: 'forms', groups: [ 'forms' ] },
        '/',
        { name: 'links', groups: [ 'links' ] },
        { name: 'insert', groups: [ 'insert' ] },
        '/',
        { name: 'tools', groups: [ 'tools' ] },
        { name: 'others', groups: [ 'others' ] },
        { name: 'about', groups: [ 'about' ] }
      ]
    };

    this.ckeConfig.removeButtons = 'Styles,Format,Strike,Subscript,Superscript,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,BidiLtr,BidiRtl,Language,Source,Save,NewPage,Preview,Print,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Redo,Find,Undo,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Link,Unlink,Anchor,Table,Flash,Image,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Maximize,ShowBlocks,About,ExportPdf';

    initSliders();

    this.loadAnswersSubscription = this.dataSvc.getLoadCarrouselAnswersEvent().subscribe(() => {
      this.loadAnswers();
    });
  }
  resetVariables(){
    this.ckString = '';
    this.shownElements= [];
    this.labels = {};
  }

  ngOnInit(): void {
    this.loadAnswers();
  }

  loadAnswers() {
    this.resetVariables();
    if (this.dataSvc.currentQuestion.Question.QuestionType !== 1030) return;

    clearInterval();
    //GET METADATA OF CARROUSEL QUESTION
    //BASED ON CREATION USES SPLITS TO GET THE DATA IN THE FORMAT THAT IT NEEDS
    //SHOW HIDE BASED ON THE NUMBER OF SLIDES RETURNED FROM METADATA
    var carrouselQuestion = this.dataSvc.currentQuestion.Question;
    if (carrouselQuestion !== null && carrouselQuestion !== undefined) {

      if (carrouselQuestion.Question.WordCount !== null && carrouselQuestion.Question.WordCount !== undefined
        && carrouselQuestion.Question.WordCount > 0) {
        this.wordCount.wordcount = carrouselQuestion.Question.WordCount;
        // setInterval(() => {
        //   this.wordCount.userWords = this.dataSvc.countAnswersWords();
        // }, 1000);
      }

      var carrouselData = carrouselQuestion.Question.Metadata.toString();
      if (carrouselData !== null && carrouselData !== undefined && carrouselData !== "") {
        var allTabs = carrouselData.split("***");
        for (var i = 1; i < allTabs.length; i++) {
          if (allTabs[i] !== null && allTabs[i] !== undefined && allTabs[i] !== "") {
            this.shownElements.push("indicator" + i);
            this.shownElements.push("carText" + i);

            var tab = allTabs[i].toString();
            tab = this.dataSvc.tikTokChecker(tab);
            this.labels['label' + i] = this.sanitizer.bypassSecurityTrustHtml(tab);
          }
        }
      }
    }
  }
}
